import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=3d50ca3e&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=3d50ca3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d50ca3e",
  null
  
)

component.options.__file = "ForgotPassword.vue"
export default component.exports